import type { Inventory } from '@libs/common-node';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getProductInventory(sku: string, stores: string[]) {
    const url = CWEA_ENDPOINTS.inventory.getProductInventory(sku);
    return await client.cwea<Inventory>(url, {
        method: 'POST',
        body: JSON.stringify({
            stores,
        }),
    });
}
